import rollForwardDate from "../../../game-views/objects/roll_forward_date_function";

export const determineBondMaturityDate = (bondInfo, startGameDate) => {
    let rollForwardMonths = 0;
    let maturityDate = "";
    //  set beginning date for bond
    let startDate = startGameDate;
    rollForwardMonths = +bondInfo.startMonthNbr - 1;
    if (rollForwardMonths > 0){
        startDate = rollForwardDate(startGameDate, rollForwardMonths);
    }
    //  set ending date (maturity date) for bond
    if (bondInfo.termUnit === "Months"){
            rollForwardMonths = +bondInfo.term;
    }else{
        if (bondInfo.termUnit === "Years"){
            rollForwardMonths = (+bondInfo.term * 12).toFixed(0);
        }
    }
    const termText = bondInfo.term + " " + bondInfo.termUnit;
    let updateMaturityDate = true;
    if (!bondInfo.maturityDate || bondInfo.maturityDate === ""){
        maturityDate = rollForwardDate(startDate, rollForwardMonths);
    }else{
        maturityDate = bondInfo.maturityDate;
        updateMaturityDate = false;
    }
    const returnObj = {startDate: startDate, maturityDate: maturityDate, updateMaturityDate: updateMaturityDate, 
        termText: termText};
    return returnObj;
}

export default determineBondMaturityDate;